import { Text, useColorModeValue, Flex, Center } from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import Card from 'components/card/Card';
import React from 'react';
import { DashboardSummary } from 'config/constant';

const AboutCard = (props) => {
  const textColor = useColorModeValue('navy.700', 'white');

  return (
    <Chakralink>
      <Link
        to={{
          pathname: DashboardSummary.find(
            (card) => card.key === props?.keyValue
          )?.url,
        }}>
        <Card
          h='100%'
          p='20px'
          backgroundColor='navy.50'
          // maxW={{ md: 'md', '3xl': 'lg' }}
          minH='180px'
          _hover={{ backgroundColor: 'navy.100' }}>
          <Text
            textAlign='left'
            color={textColor}
            fontSize={{
              base: 'xl',
              md: '2xl',
              lg: '2xl',
              xl: '2xl',
              '2xl': '2xl',
              '3xl': '2xl',
            }}
            fontWeight='semibold'>
            {props?.title}
          </Text>
          <Text
            mt='auto'
            textAlign='right'
            color={textColor}
            fontSize={{
              base: '4xl',
              md: '5xl',
              lg: '5xl',
              xl: '5xl',
              '2xl': '5xl',
              '3xl': '5xl',
            }}
            fontWeight='light'>
            {props?.Value}
          </Text>
        </Card>
      </Link>
    </Chakralink>
  );
};

export default AboutCard;
